// extracted by mini-css-extract-plugin
module.exports = {"columnNarrow":"rates_table_header_columnNarrow__1RYYX","tableHeaderWrapper":"rates_table_header_tableHeaderWrapper__2M4Qu"};